<app-section
  titleSection="Détails du dossier"
  [isActivated]="detailsDossier.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-details-dossier-read-mode [detailsDossier]="detailsDossier">
    </app-details-dossier-read-mode>
  </div>

  <div edit-mode>
    <app-details-dossier-edit-mode
      [detailsDossier]="detailsDossier"
      (detailsDossierChanged)="onDetailsDossierChanged($event)"
      [errorMessage]="errorMessage"
      [errorStatus]="errorStatus"
      (cleanError)="onCleanError()"
      (formChange)="onFormChange($event)"
    >
    </app-details-dossier-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
